import React, { useEffect, useState } from "react";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import backIcon from "../../assets/images/arrow_back_icon.svg";
import YearlyCalendar from "../../shared/YearlyCalendar";
import effortAnalysisIcon from "../../assets/images/effort-analysis-icon.png";
import { useDispatch, useSelector } from "react-redux";
import {
  capitalizeFirstLetter,
  formatAmount,
  getGenerateUrl,
  handleClickhdl,
  hardInteractionTypes,
} from "../../utils/constants";
import showAllIcon from "../../assets/images/show-all-icon.svg";
import directLineIcon from "../../assets/images/direct-meeting-blue.svg";
import virtualLineIcon from "../../assets/images/virtual-meeting-violet.svg";
import callLineIcon from "../../assets/images/phone-call-orange.svg";
import whatsappLineIcon from "../../assets/images/whatsapp-green.svg";
import emailLineIcon from "../../assets/images/email-icon-maroon.svg";
import salesProfile from "../../assets/images/salesProfile.png";
import interactionTitleIcons from "../../assets/images/interactions-title-icon.svg";
import phoneIconBlue from "../../assets/images/phone-icon-blue.svg";
import copySvg from "../../assets/images/copy.svg";

import { SetSelectedYear } from "../../redux/counterSlice";
import API from "../../services/api";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { differenceInDays, format } from "date-fns";
import { formatDate } from "../../utils/dateFormat";
import { useNavigate } from "react-router";

function BrandMonthWiseInteractions(props) {
  let { sales_person_id, brand_id, year, sales_name } = props.details;
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const dispatch = useDispatch();
  // dispatch(SetSelectedYear(year));
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const navigate = useNavigate();
  const [selectedBrandId, setSelectedBrandId] = useState(
    props.details.brand_id
  );
  const [brandsList, setBrandsList] = useState(props.details.brandsList);
  const [initialRender, setInitialRender] = useState(true);
  const [data, setData] = useState({});
  const [mainData, setMainData] = useState({});
  const [loader, setLoader] = useState(false);
  const [typeFilter, setTypeFilter] = useState(0);
  const [totalInteractions, setTotalInteractions] = useState([]);
  const [fullScreen, setFullScreen] = useState(false);

  const now = new Date();
  let total_campaigns_count = 0,
    total_w2n_count = 0,
    total_camp_spent = 0,
    total_w2n_spent = 0,
    total_missed = 0,
    total_known = 0,
    total_unknown = 0;

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const fetchBrandHistoryData = async () => {
    try {
      setLoader(true);
      let result = await API({
        url: "/effort_analysis/brand_year_history",
        method: "POST",
        responseType: "json",
        data: {
          brand_id: +selectedBrandId,
          sales_person_id: sales_person_id !== -1 ? sales_person_id : undefined,
          selectedYear,
        },
      });
      if (result.code === 200) {
        setData(result.data);
        setMainData(result.data);
        let tempResult = JSON.parse(JSON.stringify(result.data));
        if (Object.keys(tempResult).length) {
          setTotalInteractions(
            Object.keys(tempResult)
              .map((month) => tempResult[month].interactions)
              .flat()
          );
        } else {
          setTotalInteractions([]);
        }
        setTypeFilter(0);
      }
      setLoader(false);
      setInitialRender(false);
    } catch (error) {
      console.error("Error @ fetchBrandMonthInteractionsData", error);
    }
  };
  useEffect(() => {
    fetchBrandHistoryData();
  }, []);
  useEffect(() => {
    if (!initialRender) fetchBrandHistoryData();
  }, [selectedYear, selectedBrandId]);
  const handleIntTypeChange = (type) => {
    let filtereddata = {};
    if (mainData && type) {
      Object.keys(mainData).map((month) => {
        let tempData = JSON.parse(JSON.stringify(mainData[month]));
        let filteredInteractions = tempData.interactions.filter(
          (item) => item.type === type
        );
        tempData.interactions = filteredInteractions;
        filtereddata[month] = tempData;
      });
      setData(JSON.parse(JSON.stringify(filtereddata)));
    }
    if (type === 0) {
      setData(mainData);
    }
    setTypeFilter(type);
  };
  const scrollToSection = (id) => {
    document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <SlDrawer
      open={Object.keys(props).length ? true : false}
      onSlRequestClose={handleRequestClose}
      noHeader={true}
      // contained={true}
      className="intrDrawer"
      style={{ "--size": "100vw" }}
    >
      <div class="effort-analyis">
        <div class={`effortbHeader noBg ${fullScreen ? "afterToggle" : ""}`}>
          <div class="titleRow">
            <div class="pageTitle">
              {salesUsersList?.length > 1 ? (
                <button
                  class="goBack-btn"
                  onClick={() => props.setShowEffort(false)}
                >
                  <img src={backIcon} alt="" />{" "}
                  <span>Go To Dashboard</span>
                </button>
              ) : null}
              <h3>
                <i class="icon">
                  <img src={effortAnalysisIcon} alt="" />
                </i>
                <span>
                  Brand History -{" "}
                  {
                    capitalizeFirstLetter(brandsList.find((item) => item.value === +selectedBrandId)
                      ?.label)
                  }
                </span>
              </h3>
              <div class="view-navigate">
                <YearlyCalendar startYear={2023} endYear={2100} />
              </div>
              <select
                name="executive"
                id="brand-list"
                value={selectedBrandId}
                onChange={(e) => {
                  setSelectedBrandId(e.target.value);
                }}
              >
                {brandsList.map((item) => {
                  return <option value={item?.value}>{item?.label}</option>;
                })}
              </select>
            </div>
            {/* <div class="filters-more">
              <button id="filters">
                <img src="assets/images/filters-icon.png" alt="" />
              </button>
              <select name="executive" id="executive">
                <option value="choose executive" selected>
                  Choose Executive
                </option>
                <option value="">M Venkata Subba Rao</option>
                <option value="">Madhu Sudhan</option>
                <option value="">Meghna Gowde</option>
                <option value="">Naresh Kumar</option>
              </select>
            </div> */}
          </div>
        </div>

        {/* <!-- Effort Analysis - Calendar View --> */}
        <div class="view-container">
          <div class="viewHeader executiveHeader">
            <h5 class="headLabel">
              <img
                src={
                  brandsList.find((item) => item.value === selectedBrandId)
                    ?.logo_url ||
                  getGenerateUrl(
                    brandsList.find((item) => item.value === selectedBrandId)
                      ?.label || ""
                  )
                }
                alt=""
              />
            </h5>
            <ul class="tabs">
              <li>
                <button
                  class={`btn-all ${typeFilter === 0 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(0);
                  }}
                >
                  <img src={showAllIcon} alt="" /> <span>Show All</span>
                </button>
              </li>
              <li>
                <button
                  class={`btn-dir-meet ${typeFilter === 1 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(1);
                  }}
                >
                  <img src={directLineIcon} alt="" />
                  <span>Direct Meeting</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 1).length}
                  </em>
                </button>
              </li>
              <li>
                <button
                  class={`btn-vir-meet ${typeFilter === 2 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(2);
                  }}
                >
                  <img src={virtualLineIcon} alt="" />
                  <span>Virtual Meeting</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 2).length}
                  </em>
                </button>
              </li>
              <li>
                <button
                  class={`btn-calls ${typeFilter === 3 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(3);
                  }}
                >
                  <img src={callLineIcon} alt="" />
                  <span>Calls</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 3).length}
                  </em>
                </button>
              </li>
              <li>
                <button
                  class={`btn-wa-chat ${typeFilter === 4 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(4);
                  }}
                >
                  <img src={whatsappLineIcon} alt="" />
                  <span>whatsApp</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 4).length}
                  </em>
                </button>
              </li>
              <li>
                <button
                  class={`btn-emailed ${typeFilter === 5 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(5);
                  }}
                >
                  <img src={emailLineIcon} alt="" />
                  <span>Emailed</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 5).length}
                  </em>
                </button>
              </li>
            </ul>
            <div class="executive">
              <img src={salesProfile} alt="" />
              <h4>{sales_name}</h4>
            </div>
          </div>
          <div class="viewBody">
            <button
              id="changeView"
              class="mobileOnly"
              onClick={() => {
                setFullScreen(!fullScreen);
              }}
            >
              {!fullScreen ? "Full Screen View" : "Exit Full Screen View"}
            </button>
            {data && Object.keys(data)?.length && !loader ? (
              <>
                {Object.keys(data).map((month) => {
                  let monthObj = new Date(month * 1000);
                  let interactions_count = data[month].interactions;
                  let monthdata = data[month];
                  if (monthdata?.effort) {
                    total_campaigns_count =
                      +total_campaigns_count +
                      +monthdata?.effort?.total_campaigns_count;
                    total_w2n_count =
                      +total_w2n_count + +monthdata?.effort?.total_w2n_count;
                    total_camp_spent =
                      +total_camp_spent +
                      +monthdata?.effort?.total_campaigns_spent;
                    total_w2n_spent =
                      +total_w2n_spent + +monthdata?.effort?.total_w2n_spent;
                    total_missed =
                      +total_missed + +(monthdata?.effort?.total_missed || 0);
                    total_known =
                      +total_known + +monthdata?.effort?.total_known;
                    total_unknown =
                      +total_unknown + +monthdata?.effort?.total_unknown;
                  }
                  return (
                    <div class="day-interactions" id={format(monthObj, "MMM")}>
                      <div class="dateNdall">
                        <div class="day">
                          <h1>{format(monthObj, "MMM")}</h1>
                          <h5>{monthObj.getFullYear()}</h5>
                        </div>
                        <h3 class="count">
                          Intrns: <span>{monthdata?.interactions?.length}</span>
                        </h3>
                        <div class="stats competetive">
                          <h2 class="competetor-spent">
                            {formatAmount(
                              +monthdata?.effort?.total_campaigns_spent
                            )}
                          </h2>
                          <h6>Competitor Spent</h6>
                        </div>
                        <div class="stats ours">
                          <h2 class="w2n-spent">
                            {formatAmount(+monthdata?.effort?.total_w2n_spent)}
                          </h2>
                          <h6>W2N Spent</h6>
                        </div>
                      </div>
                      <div class="interactionHistory make-room">
                        {monthdata?.interactions?.map((item) => {
                          let mobileNumbers = [],
                            emails = [];
                          if (item.mobile1) mobileNumbers.push(item.mobile1);
                          if (item.mobile2) mobileNumbers.push(item.mobile2);
                          if (item.email1) emails.push(item.email1);
                          if (item.email2) emails.push(item.email2);
                          return (
                            <div
                              class={`interaction ${
                                item.type === 1
                                  ? "dir-meet"
                                  : item.type === 2
                                  ? "vir-meet"
                                  : item.type === 3
                                  ? "dir-call"
                                  : item.type === 4
                                  ? "wa-chat"
                                  : item.type === 5
                                  ? "e-mail"
                                  : ""
                              }`}
                            >
                              <div class="int-head">
                                <div class="name">
                                  <img src={interactionTitleIcons} alt="" />
                                  <h1>
                                    {capitalizeFirstLetter(item.name)} <span>{capitalizeFirstLetter(item.designation)}</span>
                                  </h1>
                                </div>
                                <div
                                  class={`meet-type ${
                                    item.type === 1
                                      ? "direct-meeting"
                                      : item.type === 2
                                      ? "virtual-meeting"
                                      : item.type === 3
                                      ? "phone-call"
                                      : item.type === 4
                                      ? "whatsapp-chat"
                                      : item.type === 5
                                      ? "email-chat"
                                      : ""
                                  }`}
                                >
                                  <img
                                    src={
                                      item.type === 1
                                        ? directLineIcon
                                        : item.type === 2
                                        ? virtualLineIcon
                                        : item.type === 3
                                        ? callLineIcon
                                        : item.type === 4
                                        ? whatsappLineIcon
                                        : item.type === 5
                                        ? emailLineIcon
                                        : ""
                                    }
                                    alt=""
                                  />
                                  <p>
                                    {item.type === 1
                                      ? "Direct Meeting"
                                      : item.type === 2
                                      ? "Virtual Meeting"
                                      : item.type === 3
                                      ? "Phone Call"
                                      : item.type === 4
                                      ? "WhatsApp"
                                      : item.type === 5
                                      ? "Email"
                                      : ""}
                                  </p>
                                </div>
                              </div>
                              <div class="int-body">
                                <p>{item.description}</p>
                              </div>
                              <div class="int-footer">
                                <h5>
                                  <img src={phoneIconBlue} alt="" />{" "}
                                  <span>{mobileNumbers[0]}</span>
                                  <img
                                    src={copySvg}
                                    alt=""
                                    onClick={() =>
                                      handleClickhdl(mobileNumbers[0])
                                    }
                                  />
                                </h5>
                                <h6>{`${differenceInDays(
                                  now,
                                  new Date(item.date * 1000)
                                )} days ago | On ${formatDate(item.date)}`}</h6>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : !(data && Object.keys(data)?.length) && !loader ? (
              <div className="w-full h-full d-flex justify-center">
                <NoDataFound />
              </div>
            ) : (
              <div className="w-full h-full d-flex justify-center">
                <TableLoader />
              </div>
            )}
          </div>
          <div
            class={`viewFooter ${fullScreen ? "toggleHeight" : ""}`}
            id="executiveProfile"
          >
            <ul class="client-navigator">
              <li
                onClick={() => {
                  scrollToSection("Jan");
                }}
                className="available"
              >
                Jan
              </li>
              <li
                onClick={() => {
                  scrollToSection("Feb");
                }}
                className="available"
              >
                Feb
              </li>
              <li
                onClick={() => {
                  scrollToSection("Mar");
                }}
                className="available"
              >
                Mar
              </li>
              <li
                onClick={() => {
                  scrollToSection("Apr");
                }}
                className="available"
              >
                Apr
              </li>
              <li
                onClick={() => {
                  scrollToSection("May");
                }}
                className="available"
              >
                May
              </li>
              <li
                onClick={() => {
                  scrollToSection("Jun");
                }}
                className="available"
              >
                Jun
              </li>
              <li
                onClick={() => {
                  scrollToSection("Jul");
                }}
                className="available"
              >
                Jul
              </li>
              <li
                onClick={() => {
                  scrollToSection("Aug");
                }}
                className="available"
              >
                Aug
              </li>
              <li
                onClick={() => {
                  scrollToSection("Sep");
                }}
                className="available"
              >
                Sep
              </li>
              <li
                onClick={() => {
                  scrollToSection("Oct");
                }}
                className="available"
              >
                Oct
              </li>
              <li
                onClick={() => {
                  scrollToSection("Nov");
                }}
                className="available"
              >
                Nov
              </li>
              <li
                onClick={() => {
                  scrollToSection("Dec");
                }}
                className="available"
              >
                Dec
              </li>
            </ul>
            <div class="execProfile">
              <div class="profile-pic">
                <img
                  src={
                    brandsList.find((item) => item.value === selectedBrandId)
                      ?.logo_url ||
                    getGenerateUrl(
                      brandsList.find((item) => item.value === selectedBrandId)
                        ?.label || ""
                    )
                  }
                  alt=""
                />
              </div>
              <div class="profile-details">
                <h1>
                  {
                    capitalizeFirstLetter(brandsList.find((item) => item.value === +selectedBrandId)
                      ?.label)
                  }{" "}
                  <i class="clients">{totalInteractions.filter(item => hardInteractionTypes.includes(item.type)).length}</i>
                </h1>
                {/* <div class="designation">
                  <p class="location">Hyderabad</p>
                </div> */}
              </div>
            </div>
            <div class="stats">
              <h2>{total_campaigns_count || 0}</h2>
              <h6>Competitor Campaigns</h6>
            </div>
            <div class="stats">
              <h2>{total_w2n_count || 0}</h2>
              <h6>W2N Campaigns</h6>
            </div>
            <div class="stats">
              <h2 class="competetor-spent">
                {formatAmount(total_camp_spent) || 0}
              </h2>
              <h6>Competitor Spent</h6>
            </div>
            <div class="stats">
              <h2 class="w2n-spent">{formatAmount(total_w2n_spent) || 0}</h2>
              <h6>W2N Spent</h6>
            </div>
            <div class="stats">
              <h2>{total_missed || 0}</h2>
              <h6>Missed</h6>
            </div>
            <div class="stats">
              <h2>{total_known || 0}</h2>
              <h6>Known</h6>
            </div>
            <div class="stats">
              <div className="percent">
              <h2>{total_unknown}</h2>
              <h5>{((total_unknown/(total_unknown + total_known) * 100) || 0).toFixed(1) }%</h5>
              </div>
            <h6>Unknown</h6>
          </div>
            <button class="history-btn" onClick={() => props.setShow(null)}>
              <img src={backIcon} alt="" />{" "}
              <span>Go back to Effort Analysis</span>
            </button>
          </div>
        </div>
      </div>
    </SlDrawer>
  );
}

export default BrandMonthWiseInteractions;
